<nz-space class="mobile-report-control">
  <app-stock-in-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="docCode">
  </app-stock-in-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-stock-in-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="docCode"></app-stock-in-select>
</nz-space>